module.exports = __webpack_public_path__ + "img/444f3636-d59a-4a3e-91b3-e12a010b0d72.d0f48776.png";